<div id="layout"></div>

<div class="header" [style.z-index]="999">
    <div class="title"></div>
    <div class="wifi-info">
        <!-- wifi area-->
        <span
            style="font-size: 20pt;line-height: 1em;border-bottom: 1px solid;height: 22pt;padding-left: 0.5em;padding-right: 0.5em;position: absolute; display: none;">ROOM
            Wi-Fi</span>
        <div class="wifi-title">
            <img src="/assets/icons/com/wifi.png" style="width: 25px;margin-right: 0.5em;">
            <span class="wifi-ssid">

                SSID：
                {{ ssid }}
            </span>
            <span class="wifi-key">

                KEY：
                {{ password }}
            </span>

        </div>
        <div class="qr_code">
            <qrcode [qrdata]="qr" [width]="95" />
        </div>

    </div>
    <div class="front-info" [ngClass]="{'front-info_eng': isEng}">
    </div>
    <div class="weather" [ngClass]="{'weather_eng': isEng}">
        <div class="weather_today">
            <span *ngIf="!isEng">本日のお天気</span>
            <span *ngIf="isEng">Today</span>
            ：
            <canvas width="38" height="38" id="today"></canvas>
            <span class="rainy">{{ today_rainy }}</span>
            <span class="temp">
                {{ today_temp }}
            </span>

        </div>
        <div class="weather_tomorrow">
            <span *ngIf="!isEng">明日のお天気</span>
            <span *ngIf="isEng">Tomorrow</span>
            ：
            <canvas width="30" height="30" id="tomorrow"></canvas>
            <span class="rainy">{{ tommorow_rainy }}</span>
            <span class="temp">
                {{ tommorow_temp }}
            </span>

        </div>

    </div>
    <div class="clock">
        <!-- clock area-->
        <div class="date">
            <div class="year">{{ now_date_obj.year }}.</div>
            <div class="month-date">{{ now_date_obj.month }}.{{ now_date_obj.day }}</div>
            <div class="week">{{ now_date_obj.day_of_week }}</div>
        </div>
        <div class="time">
            {{ now_date_obj.hhmm }}
        </div>
    </div>
</div>

<!-- Hotel HP -->
<div class="web">
    <div class="bebot_qr">
        <img src="/assets/web.jpg" width=90>
    </div>
    <div class="bebot_txt">
        Official Website
    </div>
</div>

<!-- bebot-->
<!-- <div *ngIf="isEng" class="bebot">
    <div class="bebot_qr">
        <img src="/assets/bebot.png" width=90>
    </div>
    <div class="bebot_txt">
        Hi I'm Bebot! Please read the QR Code using your phone, <br /> Feel free to ask me any questions! </div>
</div> -->

<div class="main" [style.z-index]="-1">
    <!--<div id="particles-js"></div>-->

    <div id="left">
        <ng-container *ngFor="let item of icons; let i = index">
            <div class="icon_item">
                <div (click)="aClick(i)" (blur)="blur(i)" (focus)="changeIcon(i)" class="fuga">
                    <img [hidden]="item.focused" [src]="item.icon" class="icon_img" />
                    <img [hidden]="!item.focused" [src]="item.icon" class="icon_img_focus" />
                </div>
            </div>
        </ng-container>
    </div>
</div>




<div class="room_info" [ngClass]="{'room_info_eng': isEng}">
    <span *ngIf="!isEng">
        こちらのお部屋：
    </span>
    <span *ngIf="isEng">
        This room is
    </span>
    <div class="room_number">{{ room_no }}
        <span *ngIf="!isEng">
            号室
        </span>
    </div>
</div>
<img src="assets/top-image/license-w3.png" alt="weather_license" class="weather_license">
<div class="footer">

    <div class="footer-bar"></div>
</div>